import React from 'react'
import { Box, LinearProgress } from '@material-ui/core'
import useStyles from 'Components/Views/AppBar/ProgressBar/ProgressBar.styles'

type Props = {
  progress: number
}

const ProgressBar = ({ progress }: Props) => {
  const classes = useStyles()
  return (
    <>
      <Box
        height={'16px'}
        display={'flex'}
        alignItems={'center'}
        zIndex={5}
        boxSizing={'border-box'}
        m={'20px'}
        mb={'25px'}
        mt={'5px'}
      >
        <LinearProgress
          className={classes.bar}
          variant='determinate'
          value={progress}
          color='secondary'
        />
      </Box>
    </>
  )
}

export default ProgressBar
